<template>
    <modal :modal-id="modalId"
           :title="selectedUrl ? $editLabel('job') : $createLabel('new_job')"
           :preloader="preloader"
           :modal-scroll="false"
           modal-size="large"
           @submit="submit"
           @closeModal="closeModal">

        <template slot="body">
            <app-overlay-loader v-if="preloader"/>
            <form class="mb-0"
                  :class="{'loading-opacity': preloader}"
                  ref="form"
                  :data-url="selectedUrl?selectedUrl:JOB">
                <div class="form-group row align-items-center">
                    <label for="jobTitle" class="col-sm-3 mb-0">
                        {{ $t('job_title') }}
                    </label>
                    <div class="col-sm-9">
                        <app-input
                            id="jobTitle"
                            type="text"
                            v-model="formData.name"
                            :placeholder="$placeholder('title')"
                            :required="true"
                        />
                    </div>
                </div>
                <div class="form-group row align-items-center">
                    <label for="jobType" class="col-sm-3 mb-sm-0">
                        {{ $t('job_type') }}
                    </label>
                    <div class="col-sm-9">
                        <app-input
                            id="jobType"
                            type="search-select"
                            :placeholder="$chooseLabel('job_type')"
                            :list="jobTypeList"
                            list-value-field="name"
                            :required="true"
                            v-model="formData.job_type_id"
                        />
                    </div>
                </div>
                <div class="form-group row align-items-center">
                    <label for="department" class="col-sm-3 mb-sm-0">
                        {{ $t('industry') }}
                    </label>
                    <div class="col-sm-9">
                        <app-input
                            id="department"
                            type="search-select"
                            :placeholder="$chooseLabel('industry')"
                            :list="departmentList"
                            list-value-field="name"
                            :required="true"
                            v-model="formData.department_id"
                        />
                    </div>
                </div>
                <div class="form-group row align-items-center">
                    <label for="locations" class="col-sm-3 mb-sm-0">
                        {{ $t('location') }}
                    </label>
                    <div class="col-sm-9">
                        <app-input
                            id="locations"
                            type="search-select"
                            :placeholder="$chooseLabel('location')"
                            :list="companyLocationList"
                            list-value-field="address"
                            :required="true"
                            v-model="formData.company_location_id"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label for="description" class="col-sm-3 mb-0">
                        {{ $t('description') }}
                    </label>
                    <div class="col-sm-9">
                        <!-- <app-input
                            id="description"
                            type="textarea"
                            v-model="formData.description"
                            :placeholder="$placeholder('description')"
                            :required="true"
                        /> -->
                        <app-input id="description" type="text-editor" :placeholder="$placeholder('description')" v-model="textEditor" :required="true"/>
                    </div>
                </div>
                <div class="form-group row align-items-center">
                    <label for="skills" class="col-sm-3 mb-0">
                        {{ $t('skills') }}
                    </label>
                    <div class="col-sm-9">
                        <!-- <app-input
                            id="skills"
                            type="text"
                            v-model="formData.skills"
                            :placeholder="$placeholder('skills')"
                            :required="true"
                        /> -->
                        <!-- <vue-tags-input
                            v-model="formData.skills"
                            :tags="tags"
                            @tags-changed="newTags => tags = newTags" -->
                            <div class='tag-input'>
                                <div v-for='(skill, index) in skills' :key='index' class='tag-input__tag'>
                                  {{ skill }}
                                  <span @click='removeTag(index)'>x</span>
                                </div>
                                <input
                                  type='text'
                                  placeholder="Add multiple skills by comma seprate"
                                  class='tag-input__text'
                                  @keydown.enter='addTag'
                                  @keydown.188='addTag'
                                  @keydown.delete='removeLastTag'
                                />
                            </div>
                            <div><small class="text-danger validation-error skill-err" v-if="error">This field is required</small></div>

                    </div>
                </div>
                <div class="form-group row align-items-center">
                    <label for="certificate" class="col-sm-3 mb-0">
                        {{ $t('certificate') }}
                    </label>
                    <div class="col-sm-9">
                        <!-- <app-input
                            id="certificate"
                            type="text"
                            v-model="formData.certificate"
                            :placeholder="$placeholder('certificate')"
                            :required="true"
                        /> -->
                        <div class='tag-input'>
                            <div v-for='(cert, index) in certificate' :key='index' class='tag-input__tag'>
                              {{ cert }}
                              <span @click='removeCertificate(index)'>x</span>
                            </div>
                            <input
                              type='text'
                              placeholder="Add multiple by comma seprate"
                              class='tag-input__text'
                              @keydown.enter='addCertificate'
                              @keydown.188='addCertificate'
                              @keydown.delete='removeLastCertificate'
                            />
                        </div>
                        <div><small class="text-danger validation-error certificate-err" v-if="errorcer">This field is required</small></div>
                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <label for="dutes" class="col-sm-3 mb-0">
                        {{ $t('dutes') }}
                    </label>
                    <div class="col-sm-9">
                        <app-input id="dutes" type="text-editor" :placeholder="$placeholder('dutes')" v-model="formData.dutes" :required="true"/>

                        <!-- <app-input
                            id="dutes"
                            type="text"
                            v-model="formData.dutes"
                            :placeholder="$placeholder('dutes')"
                            :required="true"
                        /> -->
                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <label for="education" class="col-sm-3 mb-sm-0">
                        {{ $t('educationDegree') }}
                    </label>
                    <div class="col-sm-9">
                         <app-input
                            id="educationDegree"
                            type="text"
                            v-model="formData.education_degree"
                            :placeholder="$placeholder('educationDegree')"
                            :required="true"
                        />
                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <label for="education" class="col-sm-3 mb-sm-0">
                        {{ $t('educationMajor') }}
                    </label>
                    <div class="col-sm-9">
                         <app-input
                            id="educationMajor"
                            type="text"
                            v-model="formData.education_title"
                            :placeholder="$placeholder('educationMajor')"
                            :required="true"
                        />
                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <label for="experience" class="col-sm-3 mb-0">
                        {{ $t('experience') }}
                    </label>
                    <div class="col-sm-9">
                        <app-input
                            id="experience"
                            type="text"
                            v-model="formData.experience"
                            :placeholder="$placeholder('experience')"
                            :required="true"
                        />
                    </div>
                </div>
                <div class="form-group row align-items-center">
                    <label for="no_of_vacancy" class="col-sm-3 mb-0">
                        {{ $t('no_of_vacancy') }}
                    </label>
                    <div class="col-sm-9">
                        <app-input
                            id="no_of_vacancy"
                            type="text"
                            v-model="formData.vacancy_count"
                            :placeholder="$placeholder('no_of_vacancy')"
                            :required="true"
                        />
                    </div>
                </div>
                <div class="form-group row align-items-center">
                    <label for="salary" class="col-sm-3 mb-0">
                        {{ $t('salary') }}
                    </label>
                    <div class="col-sm-9">
                        <app-input
                            id="salary"
                            type="text"
                            v-model="formData.salary"
                            :placeholder="$placeholder('salary in $')"
                            :required="true"
                        />
                    </div>
                </div>
                <div class="form-group row align-items-center">
                    <label for="sub-date" class="col-sm-3 mb-0">
                        {{ $t('last_submission') }}
                    </label>
                    <div class="col-sm-9">
                        <app-input
                            id="sub-date"
                            type="date"
                            :required="true"
                            v-model="formData.last_submission_date"
                            :placeholder="$t('last_submission_date')"
                        />
                    </div>
                </div>
            </form>
        </template>
    </modal>
</template>

<script>
import {FormMixin} from "../../../../core/mixins/form/FormMixin";
import {ModalMixin} from "../../../Mixins/ModalMixin";
import EditorDemoMixin from "../../Helpers/Editor/EditorDemoMixin";
import {mapGetters} from "vuex";
import {JOB} from "../../../Config/ApiUrl";
import DateFunction from "../../../../core/helpers/date/DateFunction";
import {axiosPost} from "../../../Helpers/AxiosHelper";
import axios from 'axios';
import VueTagsInput from '@johmun/vue-tags-input';

export default {
    name: 'JobAddEditModal',
    mixins: [FormMixin, ModalMixin, EditorDemoMixin],
    props: {
        tableId: {}
    },
    components: {
        VueTagsInput,
    },
    data() {
        return {
            textEditor: '',
            modalId: 'job-add-edit-Modal',
            JOB,
            editFrom: false,
            error: false,
            errorcer: false,
            skills: [],
            certificate: [],
            formData: {
                name: '',
                job_type_id: '',
                department_id: '',
                company_location_id: '',
                vacancy_count: '',
                salary: '',
                description: '',
                last_submission_date: new Date(),
                skills: [],
                certificate: [],
                dutes: '',
                experience: '',
                education_degree: '',
                education_title: '',
                job_id: '',
                job_description: {
                    job_type: '',
                    industry:'',
                    location:''
                }
            }
        }
    },
    computed: {
        ...mapGetters([
            'jobTypeList',
            'departmentList',
            'stageList',
            'companyLocationList',
            'applicationForm'
        ])
    },
    mounted() {
        $('#dutes').summernote({
            height: 100, 
            toolbar: [
                ['para', ['ul']],
            ]
        });
    },
    methods: {
        addTag(event) {
            event.preventDefault()
            let val = event.target.value.trim()
            if (val.length > 0) {
            if (this.skills.length >= 1) {
                for (let i = 0; i < this.skills.length; i++) {
                if (this.skills[i] === val) {
                    return false
                }
                }
            }
            this.skills.push(val)
            event.target.value = ''
            console.log(this.skills)
            }
        },
        removeTag(index) {
            this.skills.splice(index, 1)
        },
        removeLastTag(event) {
            if (event.target.value.length === 0) {
            this.removeTag(this.skills.length - 1)
            }
        },
        addCertificate(event) {
            event.preventDefault()
            let val = event.target.value.trim()
            if (val.length > 0) {
            if (this.certificate.length >= 1) {
                for (let i = 0; i < this.certificate.length; i++) {
                if (this.certificate[i] === val) {
                    return false
                }
                }
            }
            this.certificate.push(val)
            event.target.value = ''
            console.log(this.certificate)
            }
        },
        removeCertificate(index) {
            this.certificate.splice(index, 1)
        },
        removeLastCertificate(event) {
            if (event.target.value.length === 0) {
            this.removeTag(this.certificate.length - 1)
            }
        },
        generateSettingData() {
            this.content.title = this.formData.name;
            this.content.subtitle = this.formData.description ? this.formData.description : `${this.formData.name} - Description Here`;
            this.content.details = `${this.jobTypeList.find(item => item.id === this.formData.job_type_id)?.name} - ${this.companyLocationList.find(item => item.id === this.formData.company_location_id)?.address}`;
            let data = {};
            data.content = this.content;
            data.pageStyle = this.pageStyle;
            data.pageBlocks = this.pageBlocks
            return data;
        },
        generateStages() {
            let stages = this.stageList.filter(item => !(item.name.toLowerCase() === 'new' || item.name.toLowerCase() === 'hired' || item.name.toLowerCase() === 'disqualified')),
                stageName = stages.map(item => item.name.toLowerCase());
            return ['new', ...stageName, 'hired', 'disqualified'].toString();
        },
        submit() {
            if(this.skills.length == 0) {
                this.error = true;
            } else {
                this.error = false;
            }
            if(this.certificate.length == 0) {
                this.errorcer = true;
            } else {
                this.errorcer = false;
            }
            this.formData.description = this.textEditor;
            if (!this.selectedUrl) {
                this.formData.apply_form_settings = this.applicationForm;
                this.formData.stages = this.generateStages();
                this.formData.job_post_settings = this.generateSettingData();
            }else{
                this.formData.job_post_settings.content.title = this.formData.name;
                this.formData.job_post_settings.content.subtitle = this.formData.description ? this.formData.description : `${this.formData.name} - Description Here`;
                this.formData.job_post_settings.content.details = `${this.jobTypeList.find(item => item.id === this.formData.job_type_id)?.name} - ${this.companyLocationList.find(item => item.id === this.formData.company_location_id)?.address}`;
            }
            
            if (this.formData.last_submission_date) {
                this.formData.last_submission_date = DateFunction.getDateFormatForBackend(this.formData.last_submission_date);
            }
            console.log(this.formData.description);


            this.formData.last_submission_date = DateFunction.getDateFormatForBackend(this.formData.last_submission_date);
            // this.formData.skills = this.skills.length > 0 ? JSON.stringify(this.skills) : [];
            this.formData.skills = this.skills;
            this.formData.certificate = this.certificate;
            this.formData.job_description.job_type = this.jobTypeList.find(item => item.id === this.formData.job_type_id)?.name;
            this.formData.job_description.industry = this.departmentList.find(item => item.id === this.formData.department_id)?.name;
            this.formData.job_description.location = this.companyLocationList.find(item => item.id === this.formData.company_location_id)?.address;
            console.log(this.formData.job_description);
            this.save(this.formData);
            
            
        },
        afterSuccess(response) {
            this.$toastr.s(response.data.message);
            this.$hub.$emit(`reload-${this.tableId}`)
        },
        afterSuccessFromGetEditData({data}) {
            this.editFrom = true;
            this.formData.name = data.name;
            this.formData.job_type_id = data.job_type_id;
            this.formData.department_id = data.department_id;
            this.formData.company_location_id = data.company_location_id;
            this.formData.vacancy_count = data.vacancy_count;
            this.formData.salary = data.salary;
            this.formData.description = data.description;
            this.formData.last_submission_date = data.last_submission_date;
            this.preloader = false;
            this.formData.job_post_settings= this.selectedUrl && typeof data.job_post_settings === "string" ? JSON.parse(data.job_post_settings) : data.job_post_settings;
            this.skills = data.skills ? JSON.parse(data.skills) : [];
            this.certificate = data.certificate ? JSON.parse(data.certificate) : [];
            // this.formData.certificate = data.certificate ? data.certificate : '';
            this.formData.dutes = data.dutes ? data.dutes : '';
            this.formData.experience = data.experience ? data.experience : '';
            this.formData.education = data.education ? data.education : '';
            this.formData.education_degree = data.education_degree ? data.education_degree : '';
            this.formData.education_title = data.education_title ? data.education_title : '';
            this.formData.job_id = data.job_id ? data.job_id : '';
            $("#description").summernote('code', data.description);
            $("#dutes").summernote('code', data.dutes);
            
            this.textEditor = data.description;
            console.log($("#description").val());
            console.log("this.formData.description ",this.textEditor);
        }
    }
}
</script>

<style scoped>
    .tag-input {
    width: 100%;
    border: 1px solid #D9DFE7;
    background: #fff;
    border-radius: 4px;
    font-size: 0.9em;
    min-height: 45px;
    box-sizing: border-box;
    padding: 0 10px;
    margin-bottom: 10px;
  }

  .tag-input__tag {
    height: 24px;
    color: white;
    background-color: #667EEA;
    float: left;
    font-size: 14px;
    margin-right: 10px;
    border-radius: 15px;
    margin-top: 10px;
    line-height: 24px;
    padding: 0 8px;
    font-family: "Roboto";
  }

  .tag-input__tag > span {
    cursor: pointer;
    opacity: 0.75;
    display: inline-block;
    margin-left: 8px;
  }

  .tag-input__text {
    border: none;
    outline: none;
    font-size: 1em;
    line-height: 40px;
    background: none;
   }
</style>